module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-t1"
  }, [_vm._v("The Uncomfortable Glass Slippers")]), _vm._v(" "), _c('p', {
    staticClass: "copy-t2"
  }, [_vm._v("The Strange Sagas of Sabrina Summers, Saga 2")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("© 2020 Michele Clark McConnochie")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published in New York, New York, by Morgan James Publishing. Morgan James is a trademark of Morgan James, LLC. "), _c('a', {
    attrs: {
      "href": "http://www.MorganJamesPublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesPublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 9781642796872 paperback")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("ISBN 9781642796889 eBook")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Library of Congress Control Number: 2019943706")]), _vm._v(" "), _c('p', {
    staticClass: "copyi2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cover Design by:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Rachel Lopez")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_c('a', {
    attrs: {
      "href": "http://www.r2cdesign.com",
      "target": "_blank"
    }
  }, [_vm._v("www.r2cdesign.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyi2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Front Cover Illustration by:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Donna Murillo")]), _vm._v(" "), _c('p', {
    staticClass: "copyi2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Interior Design by:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Christopher Kirk")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_c('a', {
    attrs: {
      "href": "http://www.GFSstudio.com",
      "target": "_blank"
    }
  }, [_vm._v("www.GFSstudio.com")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("Morgan James is a proud partner of Habitat for Humanity Peninsula and Greater Williamsburg. Partners in building since 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("Get involved today! Visit"), _c('br'), _c('a', {
    attrs: {
      "href": "http://MorganJamesPublishing.com/giving-back",
      "target": "_blank"
    }
  }, [_vm._v("MorganJamesPublishing.com/giving-back")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 66
// module chunks = 0